import { MaxLengthValidatorDirective } from '../../shared/directives/max-length-validator.directive';
import { BusinessClock } from '../../core/time/business-clock.service';
import { clockView } from '../../core/time/business-time';
import { JstDate } from '../../core/time/business-time';
import { Component, OnInit, inject } from '@angular/core';
import { RouterLink, ActivatedRoute } from '@angular/router';
import { FormsModule, NgForm } from '@angular/forms';
import { PageTitleService } from '../../core/services/page-title.service';
import { MemberService } from '../../core/services/member.service';
import { NotificationService } from '../../core/services/notification.service';
import { TransactionService } from '../../core/services/transaction.service';
import { StudioService } from '../../core/services/studio.service';
import { FormFeedback } from '../../shared/components/form-feedback.component';
import { FlashService } from '../../core/services/flash.service';
import { FlashMessageComponent } from '../../shared/components/flash-message.component';
import { environment } from '../../../environments/environment';

declare const Multipayment: any;

@Component({
    selector: 'app-notification-payment',
    imports: [MaxLengthValidatorDirective, RouterLink, FormsModule, FlashMessageComponent],
    template: `
<div class="animated fadeIn container-fluid">
  <div class="card">
    <div class="card-header">
      <span><i class="fa s-icon-edit"></i>&nbsp;申請</span>
    </div>
    <div class="card-body">
      <div style="height: 1px"></div>
      <form #notificationForm="ngForm" novalidate name="notificationForm" class="col-md-12" (ngSubmit)="save(notificationForm)">
        <div class="row"><app-flash-message class="col-md-12"></app-flash-message></div>
        <div class="row">
          <div class="col-md-3 text-md-right">会員ID：</div>
          <div class="col-md-3 form-group">{{ member?.memberCode }}</div>
          <div class="col-md-3 text-md-right">会員氏名：</div>
          <div class="col-md-3 form-group">{{ member?.lastName }}&nbsp;{{ member?.firstName }}</div>
          <div class="col-md-3 text-md-right">店舗：</div>
          <div class="col-md-3 form-group">{{ member?.studio?.name }}</div>
          <div class="col-md-3 text-md-right">状態：</div>
          <div class="col-md-3 form-group">
            @if (member?.status == 0) { <span>在籍中</span> }
            @if (member?.status == 1) { <span>停止</span> }
            @if (member?.status == 2) { <span>停止（除名）</span> }
          </div>
          <div class="col-md-3 text-md-right">区分コース：</div>
          <div class="col-md-3 form-group">{{ member?.studioPlan?.name }}</div>
          <div class="col-md-3 text-md-right">支払方法：</div>
          <div class="col-md-3 form-group">
            @if (member?.payment?.paymentMethod == 0) { <span>口座振替</span> }
            @if (member?.payment?.paymentMethod == 1) { <span>クレジットカード</span> }
          </div>
          <div class="col-md-3 text-md-right">ロッカー：</div>
          <div class="col-md-3 form-group">
            @if (member?.lockerNumber == null) { <span>使用しない</span> }
            @if (member?.lockerNumber != null) { <span>{{ member?.lockerNumber?.product?.name }}</span> }
          </div>
          <div class="col-md-3 text-md-right">保険適応：</div>
          <div class="col-md-3 form-group">
            @if (member?.isInsured == 0) { <span>なし</span> }
            @if (member?.isInsured == 1) { <span>あり</span> }
          </div>
        </div>
        <hr />
        <div class="row">
          <div class="col-md-12">
            <div class="form-group row">
              <div class="col-md-6">
                <label class="col-form-label">支払方法</label>
                <select class="form-control" [(ngModel)]="select.singlePayment.paymentMethod" name="paymentMethod" required>
                  <option [ngValue]="null">選択してください</option>
                  <option [ngValue]="0">口座振替</option>
                  <option [ngValue]="1">クレジットカード</option>
                </select>
              </div>
              @if (select.singlePayment.paymentMethod == 0 && btPaymentEnabledAdmin == 1) {
                <div class="col-md-12">
                  <p class="border border-info rounded p-2 mt-2 mb-0">オンライン口座登録を利用する場合は、下記フォームの入力は不要です。「オンライン口座登録」ボタンから登録してください。</p>
                </div>
              }
              @if (select.singlePayment.paymentMethod == 0) {
                <label class="col-md-12 col-form-label">銀行コード</label>
                <div class="col-md-6">
                  <input type="text" class="form-control" [(ngModel)]="select.singlePayment.btBankCode" (ngModelChange)="select.singlePayment.btBankCode = digitsOnly($event)" name="btBankCode" placeholder="銀行コードを半角数字で入力" required minlength="4" sfMaxLength="4" pattern="^[0-9]{4}$" inputmode="numeric">
                </div>
                <label class="col-md-12 col-form-label">支店コード</label>
                <div class="col-md-6">
                  <input type="text" class="form-control" [(ngModel)]="select.singlePayment.btBranchCode" (ngModelChange)="select.singlePayment.btBranchCode = digitsOnly($event)" name="btBranchCode" placeholder="支店コードを半角数字で入力" required minlength="3" sfMaxLength="3" pattern="^[0-9]{3}$" inputmode="numeric">
                </div>
                <label class="col-md-12 col-form-label">口座種別</label>
                <div class="col-md-6">
                  <select class="form-control" [(ngModel)]="select.singlePayment.btAccountType" name="btAccountType" required>
                    <option [ngValue]="null">選択してください</option>
                    <option [ngValue]="1">普通</option>
                    <option [ngValue]="2">当座</option>
                  </select>
                </div>
                <label class="col-md-12 col-form-label">口座番号</label>
                <div class="col-md-6">
                  <input type="text" class="form-control" [(ngModel)]="select.singlePayment.btCardNum" (ngModelChange)="select.singlePayment.btCardNum = digitsOnly($event)" name="btCardNum" placeholder="口座番号を半角で入力" required minlength="7" sfMaxLength="7" pattern="^[0-9]{7}$" inputmode="numeric">
                </div>
                <label class="col-md-12 col-form-label">名義</label>
                <div class="col-md-6">
                  <input type="text" class="form-control" [(ngModel)]="select.singlePayment.btAccountName" name="btAccountName" placeholder="全角半角カナ、半角英数字およびスペースで入力" [pattern]="bankAccountNamePattern" required>
                </div>
              }
              @if (select.singlePayment.paymentMethod == 1) {
                <label class="col-md-12 col-form-label">クレジットカード番号</label>
                <div class="col-md-6">
                  <input type="text" class="form-control" [(ngModel)]="select.getGmo.CardNo" (ngModelChange)="select.getGmo.CardNo = digitsOnly($event)" name="CardNo" placeholder="クレジットカード番号を半角数字で入力" required minlength="14" sfMaxLength="16" pattern="^[0-9]{14,16}$" inputmode="numeric">
                </div>
                <label class="col-md-12 col-form-label">クレジットカード名義</label>
                <div class="col-md-6">
                  <input type="text" class="form-control" [(ngModel)]="select.getGmo.HolderName" name="HolderName" placeholder="例：SMART TARO" [pattern]="cardHolderNamePattern" required>
                </div>
                <label class="col-md-12 col-form-label">クレジットカード有効期限</label>
                <div class="col-md-2">
                  <select class="form-control" [(ngModel)]="select.getGmo.expireMonthAt" name="expireMonthAt" required>
                    <option [ngValue]="null">月</option>
                    @for (m of cc_expire_months; track m) { <option [ngValue]="m">{{ m }}</option> }
                  </select>
                </div>
                <label class="col-md-1 col-form-label">月</label>
                <div class="col-md-2">
                  <select class="form-control" [(ngModel)]="select.getGmo.expireYearAt" name="expireYearAt" required>
                    <option [ngValue]="null">年</option>
                    @for (y of cc_expire_years; track y) { <option [ngValue]="y">{{ y }}</option> }
                  </select>
                </div>
                <label class="col-md-1 col-form-label">年</label>
                <label class="col-md-12 col-form-label">クレジットカードセキュリティコード</label>
                <div class="col-md-6">
                  <input type="text" class="form-control" [(ngModel)]="select.getGmo.security" (ngModelChange)="select.getGmo.security = digitsOnly($event)" name="security" placeholder="クレジットカードのセキュリティコードを半角数字で入力" required sfMaxLength="4" pattern="^[0-9]{1,4}$" inputmode="numeric">
                </div>
              }
            </div>
            <div class="form-group row">
              <div class="col-md-12">
                <label class="col-form-label">支払方法の適用日：
                  @if (select.singlePayment.paymentMethod == 0) { <span>{{ paymentDate.nextPaymentDate0 }}</span> }
                  @if (select.singlePayment.paymentMethod == 1 && member?.payment?.paymentMethod != 1) { <span>{{ paymentDate.nextPaymentDate1 }}</span> }
                  @if (select.singlePayment.paymentMethod == 1 && member?.payment?.paymentMethod == 1) { <span>{{ paymentDate.nextPaymentDate2 }}</span> }
                </label>
              </div>
            </div>
          </div>
        </div>
        <br /><br />
        <div class="row">
          <div class="col-md-12 text-right">
            <a [routerLink]="['/notification', memberId]" class="btn bg-close text-white"><i class="fa s-icon-cancel"></i>&nbsp;閉じる</a>
            @if (select.singlePayment.paymentMethod == 0 && btPaymentEnabledAdmin == 1) {
              <button type="button" class="btn btn-info text-white" [disabled]="btPostLoading" (click)="openBtRegistration()"><i class="fa s-icon-link"></i>&nbsp;オンライン口座登録</button>
            }
            <button type="submit" class="btn btn-success" [disabled]="notificationForm.invalid || saving || completed || (member?.status != 0 && member?.status != 4)"><i class="fa s-icon-finished"></i>&nbsp;申請</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
  `
})
export class NotificationPaymentComponent implements OnInit {
  private readonly businessClock = inject(BusinessClock);
  private readonly clockContext = clockView(true);

  private pageTitleService = inject(PageTitleService);
  private memberService = inject(MemberService);
  private notificationService = inject(NotificationService);
  private flash = inject(FlashService);
  private transactionService = inject(TransactionService);
  private studioService = inject(StudioService);
  private route = inject(ActivatedRoute);

  memberId!: number;
  member: any = null;
  select: any = {
    singlePayment: { paymentMethod: null, btBankCode: '', btBranchCode: '', btAccountType: null, btCardNum: '', btAccountName: '' },
    getGmo: { CardNo: '', HolderName: '', expireMonthAt: null, expireYearAt: null, security: '' },
  };
  saving = false;
  paymentDate: any = {};
  btPaymentEnabledAdmin = 0;
  btPostLoading = false;
  cc_expire_months: number[] = [];
  cc_expire_years: string[] = [];
  completed = false;
  readonly bankAccountNamePattern = '^[ｦ-ﾟア-ン 　A-Za-z0-9\\|,.\\(\\)\\/\\-「」]+$';
  readonly cardHolderNamePattern = '^[A-Za-z0-9 ,.\\/\\-]+$';

  private batchDay = 11;
  private readonly btPostUrl = environment.btPostUrl;

  async ngOnInit(): Promise<void> {
    this.pageTitleService.set('会員別諸届申請', 'fa fa-inbox');
    this.memberId = +this.route.snapshot.params['memberId'];
    this.cc_expire_months = Array.from({ length: 12 }, (_, i) => i + 1);
    const currentYear = new JstDate().getFullYear();
    this.cc_expire_years = Array.from({ length: 11 }, (_, i) => String(currentYear + i).slice(-2));
    this.batchDay = await this.transactionService.getBatchSchedule().catch(() => 11) ?? 11;
    this.paymentDate = this.buildPaymentDate(this.batchDay);
    this.member = await this.memberService.getOne(this.memberId);
    if (this.member?.studio?.id) {
      const studio: any = await this.studioService.list(this.member.studio.id);
      this.btPaymentEnabledAdmin = Number(studio?.btPaymentEnabledAdmin || 0);
    }
  }

  buildPaymentDate(batchDay: number): any {
    const now = new JstDate();
    const isAfter = now.getDate() >= batchDay;
    const nextMonth = new JstDate(now.getFullYear(), now.getMonth() + 1);
    const afterTwo = new JstDate(now.getFullYear(), now.getMonth() + 2);
    return {
      nextPaymentDate0: isAfter
        ? `${nextMonth.getFullYear()}年${('0' + (nextMonth.getMonth() + 1)).slice(-2)}月末`
        : `${now.getFullYear()}年${('0' + (now.getMonth() + 1)).slice(-2)}月末`,
      nextPaymentDate1: isAfter
        ? `${afterTwo.getFullYear()}年${('0' + (afterTwo.getMonth() + 1)).slice(-2)}月01日`
        : `${nextMonth.getFullYear()}年${('0' + (nextMonth.getMonth() + 1)).slice(-2)}月01日`,
      nextPaymentDate2: `${nextMonth.getFullYear()}年${('0' + (nextMonth.getMonth() + 1)).slice(-2)}月01日`,
    };
  }

  openBtRegistration(): void {
    if (this.btPostLoading) return;
    const targetName = `bt-register-${Date.now()}`;
    const popup = window.open('', targetName);
    if (!popup) {
      this.showFeedback('warning', '口座登録ページを開けませんでした。ポップアップブロックを解除してください。');
      return;
    }
    this.btPostLoading = true;
    this.memberService.createBtPostValues({ memberId: this.memberId, paymentMethod: this.select.singlePayment.paymentMethod })
      .then((result: any[]) => {
        this.btPostLoading = false;
        if (!Array.isArray(result) || result.length === 0) {
          popup.close();
          this.showFeedback('warning', '口座登録情報の取得に失敗しました。');
          return;
        }
        this.buildBtForm(this.btPostUrl, result, targetName);
        popup.focus();
      })
      .catch(() => {
        this.btPostLoading = false;
        popup.close();
        this.showFeedback('warning', '口座登録情報の取得に失敗しました。');
      });
  }

  private buildBtForm(postUrl: string, values: { key: string; value: string }[], targetName: string): void {
    const form = document.createElement('form');
    form.method = 'POST';
    form.action = postUrl;
    form.target = targetName;
    form.acceptCharset = 'Windows-31J';
    values.forEach((item) => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = item.key;
      input.value = item.value;
      form.appendChild(input);
    });
    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
  }

  async save(form?: NgForm): Promise<void> {
    if (!await this.businessClock.confirm(this.clockContext, () => this.refreshClockDates())) return;
    if (form?.invalid || this.isPaymentInputInvalid() || this.saving || this.completed || (this.member?.status != 0 && this.member?.status != 4)) {
      form?.control.markAllAsTouched();
      if (!this.saving && !this.completed) {
        this.showFeedback('warning', '入力内容を確認してください');
      }
      return;
    }
    const paymentMethod = Number(this.select.singlePayment.paymentMethod);
    const now = new JstDate();
    const modify = now.getDate() >= this.batchDay ? 2 : 1;
    const json: any = {
      studioId: this.member.studio.id,
      memberId: this.member.id,
      requestMonth: now.getFullYear() + '-' + ('0' + (now.getMonth() + 1)).slice(-2),
      status: 2,
      requestType: 6,
      beforePaymentMethod: this.member.payment?.paymentMethod,
      afterPaymentMethod: paymentMethod,
    };

    this.saving = true;
    try {
      if (paymentMethod === 0) {
        if (this.select.singlePayment.btAccountName) {
          this.select.singlePayment.btAccountName = this.convertFullToHalf(this.select.singlePayment.btAccountName);
        }
        const payload = {
          paymentMethod,
          btBankCode: this.select.singlePayment.btBankCode,
          btBranchCode: this.select.singlePayment.btBranchCode,
          btAccountType: this.select.singlePayment.btAccountType,
          btCardNum: this.select.singlePayment.btCardNum,
          btAccountName: this.select.singlePayment.btAccountName,
          memberId: this.member.id,
          memberCode: this.member.memberCode,
        };
        await this.memberService.createPayment(this.member.id, payload);
        // 旧版 notification-payment.js:118-120: 支払方法登録後に Flash・先頭へscroll
        this.showFeedback('success', '支払方法を更新しました');
        json.startDate = new JstDate(now.getFullYear(), now.getMonth() + modify, 0);
        const result = await this.notificationService.upsert(json);
        if (!result) {
          this.showFeedback('danger', '諸届申請を更新できませんでした');
          return;
        }
        this.completed = true;
        this.resetInputs(form);
        this.showFeedback('success', '諸届申請を更新しました');
      } else if (paymentMethod === 1) {
        if (!new RegExp(this.cardHolderNamePattern).test(this.select.getGmo.HolderName)) {
          this.showFeedback('warning', '名義には半角英字および記号を入力してください');
          this.saving = false;
          return;
        }
        const expire = String(this.select.getGmo.expireYearAt) + ('0' + String(this.select.getGmo.expireMonthAt)).slice(-2);
        await new Promise<void>((resolve, reject) => {
          Multipayment.init(environment.shopId);
          Multipayment.getToken({
            holdername: this.select.getGmo.HolderName,
            cardno: this.select.getGmo.CardNo,
            expire,
            securitycode: this.select.getGmo.security,
          }, async (res: any) => {
            if (!await this.businessClock.confirm(this.clockContext, () => this.refreshClockDates())) { resolve(); return; }
            if (res.resultCode === '000' && res.tokenObject?.token) {
              const payload = {
                paymentMethod,
                memberId: this.member.id,
                memberCode: this.member.memberCode,
                gmo: { username: this.select.getGmo.HolderName, token: res.tokenObject.token },
              };
              const data = await this.memberService.createPayment(this.member.id, payload);
              if ((data as any)?.message) {
                this.showFeedback('warning', (data as any).message);
                reject(new Error((data as any).message));
              } else {
                // 旧版 notification-payment.js:145-147: 支払方法登録後に Flash・先頭へscroll
                this.showFeedback('success', '支払方法を更新しました');
                json.startDate = new JstDate(now.getFullYear(), now.getMonth() + modify, 1);
                const result = await this.notificationService.upsert(json);
                if (!result) {
                  this.showFeedback('danger', '諸届申請を更新できませんでした');
                  reject(new Error('notification upsert failed'));
                  return;
                }
                this.completed = true;
                this.resetInputs(form);
                this.showFeedback('success', '諸届申請を更新しました');
                resolve();
              }
            } else {
              this.showFeedback('warning', 'クレジットカード情報を再度入力してください');
              reject(new Error('GMO token error'));
            }
          });
        });
      }
    } catch {
      // errors surfaced via alert above
    } finally {
      this.saving = false;
    }
  }

  private convertFullToHalf(str: string): string {
    const full = ['ア','イ','ウ','エ','オ','カ','キ','ク','ケ','コ','サ','シ','ス','セ','ソ','タ','チ','ツ','テ','ト','ナ','ニ','ヌ','ネ','ノ','ハ','ヒ','フ','ヘ','ホ','マ','ミ','ム','メ','モ','ヤ','ヰ','ユ','ヱ','ヨ','ラ','リ','ル','レ','ロ','ワ','ヲ','ン','ガ','ギ','グ','ゲ','ゴ','ザ','ジ','ズ','ゼ','ゾ','ダ','ヂ','ヅ','デ','ド','バ','ビ','ブ','ベ','ボ','パ','ピ','プ','ペ','ポ','ァ','ィ','ゥ','ェ','ォ','ャ','ュ','ョ','ッ','゛','°','、','。','「','」','ー','・'];
    const half = ['ｱ','ｲ','ｳ','ｴ','ｵ','ｶ','ｷ','ｸ','ｹ','ｺ','ｻ','ｼ','ｽ','ｾ','ｿ','ﾀ','ﾁ','ﾂ','ﾃ','ﾄ','ﾅ','ﾆ','ﾇ','ﾈ','ﾉ','ﾊ','ﾋ','ﾌ','ﾍ','ﾎ','ﾏ','ﾐ','ﾑ','ﾒ','ﾓ','ﾔ','ｲ','ﾕ','ｴ','ﾖ','ﾗ','ﾘ','ﾙ','ﾚ','ﾛ','ﾜ','ｦ','ﾝ','ｶﾞ','ｷﾞ','ｸﾞ','ｹﾞ','ｺﾞ','ｻﾞ','ｼﾞ','ｽﾞ','ｾﾞ','ｿﾞ','ﾀﾞ','ﾁﾞ','ﾂﾞ','ﾃﾞ','ﾄﾞ','ﾊﾞ','ﾋﾞ','ﾌﾞ','ﾍﾞ','ﾎﾞ','ﾊﾟ','ﾋﾟ','ﾌﾟ','ﾍﾟ','ﾎﾟ','ｧ','ｨ','ｩ','ｪ','ｫ','ｬ','ｭ','ｮ','ｯ','ﾞ','ﾟ','､','｡','｢','｣','ｰ','･'];
    let result = str;
    for (let i = 0; i < full.length; i++) {
      result = result.split(full[i]).join(half[i]);
    }
    return result;
  }

  digitsOnly(value: any): string {
    return String(value ?? '').replace(/[^0-9]/g, '');
  }

  private isPaymentInputInvalid(): boolean {
    const paymentMethod = Number(this.select.singlePayment.paymentMethod);
    if (paymentMethod === 0) {
      return !/^[0-9]{4}$/.test(this.select.singlePayment.btBankCode ?? '')
        || !/^[0-9]{3}$/.test(this.select.singlePayment.btBranchCode ?? '')
        || !/^[0-9]{7}$/.test(this.select.singlePayment.btCardNum ?? '')
        || !new RegExp(this.bankAccountNamePattern).test(this.select.singlePayment.btAccountName ?? '')
        || (this.select.singlePayment.btAccountType === null || this.select.singlePayment.btAccountType === undefined);
    }
    if (paymentMethod === 1) {
      return !/^[0-9]{14,16}$/.test(this.select.getGmo.CardNo ?? '')
        || !new RegExp(this.cardHolderNamePattern).test(this.select.getGmo.HolderName ?? '')
        || !this.select.getGmo.expireMonthAt
        || !this.select.getGmo.expireYearAt
        || !/^[0-9]{1,4}$/.test(this.select.getGmo.security ?? '');
    }
    return true;
  }

  private showFeedback(type: FormFeedback['type'], text: string): void {
    // 旧版 notification-*.js の Flash.create（danger 10秒・それ以外 5秒、閉じる付き）、表示位置はフォーム先頭の <flash-message>
    this.flash.create(type, text, type === 'danger' ? 10000 : 5000);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  private resetInputs(form?: NgForm): void {
    this.select = {
      singlePayment: { paymentMethod: null, btBankCode: '', btBranchCode: '', btAccountType: null, btCardNum: '', btAccountName: '' },
      getGmo: { CardNo: '', HolderName: '', expireMonthAt: null, expireYearAt: null, security: '' },
    };
    form?.resetForm({
      paymentMethod: null,
      btBankCode: '',
      btBranchCode: '',
      btAccountType: null,
      btCardNum: '',
      btAccountName: '',
      CardNo: '',
      HolderName: '',
      expireMonthAt: null,
      expireYearAt: null,
      security: '',
    });
  }
  private refreshClockDates(): void {
    this.paymentDate = this.buildPaymentDate(this.batchDay);
  }

}
